export default __webpack_public_path__ + "static/media/trending-ext.418b287b.gif";